<template>
  <v-btn app v-scroll="onScroll" v-show="fab" fab dark fixed bottom right class="btn-to-top" @click="toTop">
    <v-icon>$vuetify.icons.chevron</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "ToTopButton",
  data: () => ({
    fab: false
  }),
  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    }
  }
};
</script>


<style lang="scss" scoped>
  .btn-to-top {
    background: cornflowerblue ;
    color: white;
  }
</style>